export type AppTranslations = Record<string, unknown>;

export function translate(
    translations: AppTranslations,
    key: string,
    replace?: Record<string, string | number>,
): string {
    const parts = key.split('.');
    let node: unknown = translations;

    for (const part of parts) {
        if (node == null || typeof node !== 'object') {
            return key;
        }
        node = (node as Record<string, unknown>)[part];
    }

    if (typeof node !== 'string') {
        return key;
    }

    let text = node;
    if (replace) {
        for (const [name, value] of Object.entries(replace)) {
            text = text.replaceAll(`:${name}`, String(value));
        }
    }

    return text;
}

export const LOCALE_TAGS: Record<string, string> = {
    pt_BR: 'pt-BR',
    en: 'en-US',
    es: 'es',
    zh_CN: 'zh-CN',
};

export function localeTag(locale: string): string {
    return LOCALE_TAGS[locale] ?? 'pt-BR';
}
